export default __webpack_public_path__ + "static/media/2681.59979af1.png";